import { Component, ViewChild, ElementRef,OnInit} from '@angular/core';
@Component({
    selector: 'app-home-two',
    templateUrl: './home-two.component.html',
    styleUrls: ['./home-two.component.scss']
})
export class HomeTwoComponent implements OnInit {
    @ViewChild('videoPlayer') videoPlayer: ElementRef<HTMLVideoElement>;
    @ViewChild('playIcon') playIcon: ElementRef<HTMLAnchorElement>;
    @ViewChild('closeIcon') closeIcon: ElementRef<HTMLAnchorElement>;
    @ViewChild('videoContainer') videoContainer: ElementRef<HTMLDivElement>;
    showQrCode: boolean = false;
    isMobileDev: boolean = false;
    videoSrc: string;
    constructor() { }

    ngOnInit(): void {
        this.isMobile();
    }

    closeQrCodePopup() {
        this.showQrCode = !this.showQrCode;
    }

    isMobile(): void {
        if (window.innerWidth <= 500) {
            this.videoSrc = 'https://www.youtube.com/watch?v=61I4FbTt8_k'; // Mobile video link
            this.isMobileDev = true;
        } else {
            this.videoSrc = 'https://www.youtube.com/watch?v=Pks8rfqcMk0'; // Desktop video link
            this.isMobileDev = false;
        };
    }

    playVideo(): void {
        if (this.videoPlayer.nativeElement.muted) {
            this.videoPlayer.nativeElement.muted = false; // Unmute the video when play is clicked
        }
        this.videoPlayer.nativeElement.play();
        this.videoContainer.nativeElement.style.display = 'flex'; // Show video and context
        this.playIcon.nativeElement.style.display = 'none'; // Hide the play icon
    }

    hideVideo(): void {
        this.videoPlayer.nativeElement.pause();
        this.videoContainer.nativeElement.style.display = 'none'; // Hide video and context
        this.playIcon.nativeElement.style.display = 'flex'; // Show play icon again
    }

    toggleSound(): void {
        this.videoPlayer.nativeElement.muted = !this.videoPlayer.nativeElement.muted; // Toggle sound
    }
}
